var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bg-white p-2 mb-2",class:'border-'+_vm.color},[_c('small',{staticClass:"pb-0",class:'text-'+_vm.color},[_c('i',{staticClass:"icon-info mr-2"}),_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }